import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  container: {
    textDecoration: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexBasis: '100%',
    flexGrow: 0,
    marginRight: 5,
    marginBottom: 10
  },
  textContainer: {
    flexGrow: 2
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: colour.grey[200],
    marginLeft: 10,
    width: '100%',
    display: 'block'
  },
  order: {
    fontSize: 16,
    fontWeight: 600,
    color: colour.grey[300],
    marginRight: 15
  },
  time: {
    fontSize: 14,
    color: colour.grey[300],
    marginTop: 5,
    marginLeft: 10
  }
});
